// extracted by mini-css-extract-plugin
export var chip = "_4z-0";
export var filterDropdown = "_4z-5";
export var filterItem = "_4z-6";
export var icon = "_4z-1";
export var removeButton = "_4z-3";
export var removeIcon = "_4z-4";
export var separator = "_4z-2";